/** What ONDO guarantees about a work — shown alongside the hero image. */
export const PROMISES = [
  { icon: "✦", text: "Has a clear proof of current ownership" },
  {
    icon: "◈",
    text: "Benefits from blockchain-verified provenance backed by an immutable transfer history from first registration",
  },
  { icon: "◉", text: "Is supported by an artist-backed certificate of authenticity" },
  { icon: "⟶", text: "Is entered into the artist's catalogue raisonné" },
] as const;

/** Placeholder names until real artist and estate partners are confirmed. */
export const TRUSTED_NAMES = [
  "XYZ Artist",
  "John Doe Estate",
  "XYZ Artist",
  "John Doe Estate",
  "XYZ Artist",
  "John Doe Estate",
];
